module.exports = __webpack_public_path__ + "static/LaBelleAurore-Regular-7a47344d63614e02e6cb0febc715d23e.ttf";